import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { VacancyDetails, VacancyForm } from 'src/app/services/interface/vacancy.model'
import { CMSService } from 'src/app/services/cms.service'
import { Editor, toDoc, toHTML, Toolbar } from 'ngx-editor'

interface options {
  id: string
  title: string
}

@Component({
  selector: 'app-edit-vacancy',
  templateUrl: './edit-vacancy.component.html',
  styleUrls: ['./edit-vacancy.component.scss'],
})
export class EditVacancyComponent implements OnInit {
  @Input() id: string
  editor: Editor
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ]
  form: FormGroup
  deptArr: options[] = []
  sectionArr: options[] = [
    {
      id: 'Full Time',
      title: 'Full Time',
    },
    {
      id: 'Part Time',
      title: 'Part Time',
    },
    {
      id: 'Internship',
      title: 'Internship',
    },
  ]
  constructor(
    private fb: FormBuilder,
    private cmsService: CMSService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modal: NzModalRef,
  ) {
    this.form = this.fb.group({
      title: [null, Validators.compose([Validators.required])],
      category: [null, Validators.compose([Validators.required])],
      content: [null, Validators.compose([Validators.required])],
      departmentId: [null, Validators.compose([Validators.required])],
      status: [null, Validators.compose([Validators.required])],
    })
  }

  ngOnDestroy(): void {
    this.editor = new Editor()
  }

  detailsData: VacancyDetails
  isLoading: boolean = true
  ngOnInit(): void {
    this.cmsService.deptOption().subscribe((r: any) => {
      this.deptArr = r
    })
    this.editor = new Editor()

    this.fetchVacancyDetails()
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
  }

  fetchVacancyDetails() {
    this.isLoading = true
    this.cmsService.detailVacancy(this.id).subscribe(
      (r: VacancyDetails) => {
        this.detailsData = r

        this.form.patchValue(this.detailsData)
        this.form.patchValue({ content: toDoc(this.detailsData.content) })
        this.isLoading = false
        for (const i in this.form.controls) {
          if (this.form.controls.hasOwnProperty(i)) {
            this.form.controls[i].markAsDirty()
            this.form.controls[i].updateValueAndValidity()
          }
        }
      },
      err => {
        this.notification.error('Error', err.error.message)
      },
    )
  }

  submitForm(): boolean {
    this.isLoading = true
    this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })

    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    if (this.form.valid) {
      var formSubs: VacancyForm = this.form.value
      formSubs.id = this.id
      // formSubs.content = toHTML(this.form.value.content)
      this.cmsService.updateVacancy(formSubs).subscribe(
        r => {
          this.notification.success('Success', r.message)
          this.isLoading = false
          this.modal.destroy()
          this.fetchVacancyDetails()
          return true
        },
        err => {
          this.notification.error('Error', err.error.message)
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          this.fetchVacancyDetails()
          return false
        },
      )
    } else {
      this.msg.error('Please Fill Blank Form')
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      this.fetchVacancyDetails()
      return false
    }
  }
}
